<template>
  <div class="my-5 editBG mx-0 px-0">
    <v-form class="px-3 px-0" style="border-top: solid 1px">
      <v-card class="px-0 mx-0 mt-3 pt-2 editBG elevation-0">
        <v-layout row pt-1 pl-3 pb-0>
          <v-flex>
            <v-subheader
              class="headline black--text pl-3 ml-0 font-weight-light"
              >Add New Artist
              <span v-if="artist.name"> - {{ artist.name }}</span>
              <v-btn-toggle
                small
                mandatory
                v-model="artist.collective"
                label="Collective"
                class="ml-5"
              >
                <v-btn small flat value="0">
                  <v-icon small class="mr-2">person</v-icon>Single
                </v-btn>
                <v-btn small flat value="1">
                  <v-icon small class="mr-2">people</v-icon> Collective
                </v-btn>
              </v-btn-toggle>

              <!-- Options -->
              <v-spacer></v-spacer>
              <!-- <a @click="options_c=false" class="font-weight-regular display-1 white--text"> X</a> -->
              <v-btn
                @click="
                  options = false
                  $router.go(-1)
                "
                icon
              >
                <v-icon color="black">close</v-icon>
              </v-btn>

              <!-- <v-btn small flat @click="clearFilters()">X</v-btn> -->
            </v-subheader>
          </v-flex>
        </v-layout>

        <v-container grid-list-xs fluid py-0 my-0 px-4>
          <v-layout row wrap px-1>
            <!-- <v-card-title> -->
            <!-- <v-toolbar tabs color="white elevation-1" class="mr-5" style=""> -->
            <!-- <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn> -->
            <!-- <v-toolbar-title class="layout row wrap xs12">
                Add New Artist
                <v-spacer></v-spacer>
                <a
                  class="headline mr-3 pr-3 pt-4 right black--text"
                  @click="options=false;$router.go(-1)"
                >x</a>
              </v-toolbar-title> -->
            <!-- <v-divider></v-divider> -->

            <!-- <v-spacer></v-spacer> -->
            <!-- <v-menu bottom right>
                <v-btn slot="activator" icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="addToSelection(artist.id)">
                    <v-list-tile-title>Add this artwork to list</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>-->
            <!-- <v-btn icon><v-icon>more_vert</v-icon></v-btn> -->
            <!-- <small v-if="artworkFormData.artist">{{artworkFormData.artist.name}}</small> -->
            <!-- <v-tabs slot="extension" color="transparent" slider-color="purple"  align-with-title v-model="currentTab" show-arrows-->
            <!-- </v-toolbar>-->
            <!-- </v-card-title> -->
            <v-card-text class="px-0 mt-0 pt-0">
              <v-container
                grid-list-xs
                px-0
                py-0
                my-0
                mx-0
                style="width: 100%; max-width: 1900px"
              >
                <v-layout wrap>
                  <v-flex xs12 class="pr-3">
                    <!-- <v-switch v-model="artist.collective" label="Collective" value="1" color="black"></v-switch> -->
                    <small v-if="artist.collective == 1">
                      Create each artist which is part of this collective first.
                      <br />Information entered below is related only to group
                      of artists. It does'nt change info about each solo artist.
                    </small>
                  </v-flex>

                  <section-header text="Basic" class="mb-3"></section-header>

                  <v-flex xs12 sm6 class="mb-3 px-3">
                    <v-text-field
                      hide-details
                      @keyup="check_name($event.target.value)"
                      hint="used for all views"
                      v-model="artist.name"
                      :label="
                        artist.collective == 1 ? 'Collective Name' : 'Full Name'
                      "
                    ></v-text-field>
                    <div class="red--text" v-if="name_exists">
                      Artist with this name already exists!
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 class="pr-3">
                    <v-text-field
                      label="Sort Name"
                      hint="used for sorting in list views"
                      v-model="artist.sort_name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="px-3" v-if="artist.collective != 1">
                    <v-text-field
                      v-model="artist.first_name"
                      label="First Name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="pr-0" v-if="artist.collective != 1">
                    <v-text-field
                      v-model="artist.last_name"
                      label="Last Name"
                    ></v-text-field>
                  </v-flex>

                  <!-- <v-flex px-3 pb-3 xs12 md6 v-if="artist.collective == 1">
                    <v-text-field
                      disabled
                      label="First Name"
                      v-model="artist.first_name"
                      hint="legacy field not used anymore"
                      persistent-hint
                    ></v-text-field>
                  </v-flex>

                  <v-flex px-3 pb-3 xs12 md6 v-if="!artist.collective == 1">
                    <v-text-field
                      disabled
                      label="Last Name"
                      v-model="artist.last_name"
                      hint="legacy field not used anymore"
                      persistent-hint
                    ></v-text-field>
                  </v-flex> -->

                  <v-flex px-3 pb-3 xs12 md6 v-if="artist.collective != 1">
                    <v-text-field
                      label="Birth Name"
                      v-model="artist.birth_name"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <section-header
                    text="Birth & Death / Formation"
                    class="mb-3"
                  ></section-header>

                  <!-- BIRTH DATE -->
                  <v-flex xs12 sm6 d-flex pl-0>
                    <v-flex xs12 sm4 pl-3 py-3>
                      <v-text-field
                        v-model="artist.birth_date_year"
                        label="Year"
                        placeholder="0000"
                        mask="####"
                        type="number"
                        :maxlength="4"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 mt-0 py-3 px-2>
                      <v-text-field
                        v-model="artist.birth_date_month"
                        label="Month"
                        mask="##"
                        placeholder="00"
                        type="number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 mt-0 py-3 pr-3>
                      <v-text-field
                        v-model="artist.birth_date_day"
                        label="Day"
                        mask="##"
                        placeholder="00"
                        type="number"
                      ></v-text-field>
                    </v-flex>
                  </v-flex>

                  <!-- DEATH DATE -->
                  <v-flex xs12 sm6 d-flex>
                    <v-flex
                      xs6
                      class="mt-3 py-0 pl-3"
                      v-if="
                        artist.death_date_only_year == 1 ||
                        artist.collective == 1
                      "
                    >
                      <v-text-field
                        clearable
                        v-model="artist.death_date_year"
                        mask="####"
                        label="Death Year"
                        prepend-inner-icon="event"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs6 class="mt-3 py-0 pl-3" v-else>
                      <v-menu
                        v-if="
                          !artist.death_date_only_year ||
                          artist.death_date_only_year == 0 ||
                          artist.death_date_only_year == '' ||
                          artist.death_date_only_year == false ||
                          artist.collective != 1
                        "
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="32"
                        :nudge-top="18"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          v-if="
                            artist.death_date_only_year ||
                            artist.death_date_only_year == 0 ||
                            artist.death_date_only_year == '' ||
                            artist.death_date_only_year == false ||
                            artist.collective != 1
                          "
                          slot="activator"
                          v-model="artist.death_date"
                          label="Death Date"
                          prepend-inner-icon="event"
                          readonly
                          clearable
                        ></v-text-field>
                        <v-date-picker
                          v-model="artist.death_date"
                          @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex
                      xs6
                      class="mt-3 py-0 px-3"
                      v-if="artist.collective != 1"
                    >
                      <v-checkbox
                        v-model="artist.death_date_only_year"
                        color="black"
                        label="Only Year"
                      ></v-checkbox>
                    </v-flex>
                  </v-flex>

                  <v-flex pl-3 pr-2 xs12 sm6>
                    <!-- <label>Birth Place</label> -->
                    <v-text-field
                      :label="
                        artist.collective == 1
                          ? 'Formation place'
                          : 'Birth place'
                      "
                      v-model="artist.birthplace"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 pr-0 mt-0 mb-4>
                    <v-autocomplete
                      hide-details
                      :items="this.countries"
                      v-model="artist.nationality"
                      :label="
                        artist.collective == 1
                          ? 'Formation country'
                          : 'Nationality'
                      "
                      :item-value="(item) => item.name.common"
                      :item-text="(item) => item.name.common"
                    ></v-autocomplete>
                    <small
                      v-if="
                        !artist.nationality &&
                        artist.nationality != 0 &&
                        artist.nationality != '' &&
                        artist.nationality != null
                      "
                      class="pt-1 grey--text"
                    >
                      {{
                        this.countries.find(
                          (c) => c.name.common === artist.nationality
                        ).region
                      }}
                      /
                      {{
                        this.countries.find(
                          (c) => c.name.common === artist.nationality
                        ).subregion
                      }}
                    </small>
                  </v-flex>

                  <!-- <v-flex xs12 sm6 pr-3 v-if="artist.collective==1">
                    <v-autocomplete hide-details 
                      :items="this.countries"
                      v-model="artist.birth_country"
                      label="Formation country"
                      :item-value="item => item.name.common"
                      :item-text="item => item.name.common"
                    ></v-autocomplete>
                    <small v-if="artist.birth_country != '' && artist.birth_country != null" class="pt-1 grey--text">
                      {{ this.countries.find(c => c.name.common === artist.birth_country).region }} / 
                      {{ this.countries.find(c => c.name.common === artist.birth_country).subregion }}
                    </small>
                    <span v-else class="pt-1"></span>
                  </v-flex> -->

                  <!-- <v-flex xs12 sm6 class="pr-3">
                    <v-text-field
                      v-model="artist.birth_city"
                      :label="artist.collective==1 ? 'Formation city' : 'Birth city'"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-autocomplete
                      :items="this.countries"
                      v-model="artist.birth_country"
                      :label="artist.collective==1 ? 'Formation country' : 'Birth country'"
                    ></v-autocomplete>
                  </v-flex> -->

                  <!-- <v-flex xs12 d-flex>
                    <v-flex xs12 sm4 mt-0 pr-3>
                      <v-text-field
                        v-model="artist.birth_date_year"
                        label="Year"
                        placeholder="XXXX"
                        mask="####"
                        type="number"
                        :maxlength="4"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 mt-0 pr-3>
                      <v-text-field
                        v-model="artist.birth_date_month"
                        label="Month"
                        mask="##"
                        placeholder="XX"
                        type="number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 mt-0>
                      <v-text-field
                        v-model="artist.birth_date_day"
                        label="Day"
                        mask="##"
                        placeholder="XX"
                        type="number"
                      ></v-text-field>
                    </v-flex>
                  </v-flex> -->

                  <!-- <v-flex xs12 sm6 class="pr-3 mt-0">
                    <v-text-field v-model="artist.livesandworks_city" label="Lives & works - city"></v-text-field>
                  </v-flex> -->

                  <!-- <v-flex xs12 sm6 pr-0>
                    <v-autocomplete
                      hide-details
                      :items="this.countries"
                      v-model="artist.livesandworks_country"
                      label="Lives & works - country"
                      :item-value="item => item.name.common"
                      :item-text="item => item.name.common"
                    ></v-autocomplete>
                    <small v-if="artist.livesandworks_country != '' && artist.livesandworks_country != null" class="pt-1 grey--text">
                      {{ this.countries.find(c => c.name.common === artist.livesandworks_country).region }} / 
                      {{ this.countries.find(c => c.name.common === artist.livesandworks_country).subregion }}
                    </small>
                  </v-flex> -->

                  <v-flex
                    xs12
                    mt-5
                    mb-0
                    pl-0
                    ml-0
                    v-if="!artist.collective == 1"
                  >
                    <v-btn-toggle v-model="artist.gender">
                      <v-btn
                        small
                        flat
                        v-for="s in constants.GENDERS"
                        :key="s.name"
                        class="px-2"
                        :value="s.name"
                      >
                        <span> {{ s.name }} </span>
                      </v-btn>
                    </v-btn-toggle>
                    <!-- <v-radio-group v-model="artist.gender" row label="Gender">
                      <v-radio :label="g.name" :value="g.value" class="ml-3" color="black" v-for="g in constants.GENDERS" :key="g.id"></v-radio>
                    </v-radio-group> -->
                  </v-flex>

                  <section-header text="Other"></section-header>

                  <v-flex xs12 sm12 md12 pr-0 pl-0 mt-4>
                    <v-textarea
                      v-model="artist.livesandworks"
                      label="Lives and works"
                      auto-grow
                      box
                      hide-details
                      clearable
                      rows="1"
                    ></v-textarea>
                  </v-flex>

                  <v-flex px-0 mt-4 xs12 v-if="artist.collective != 1">
                    <v-textarea
                      class="my-0"
                      auto-grow
                      box
                      rows="1"
                      hide-details
                      v-model="artist.bio"
                      label="Bio"
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12 sm12 md12 pr-0 pl-0 mt-4>
                    <v-textarea
                      v-model="artist.birth_date_text"
                      label="Note"
                      auto-grow
                      box
                      hide-details
                      clearable
                      rows="1"
                    ></v-textarea>
                  </v-flex>

                  <v-flex
                    xs6
                    class="mx-3 mt-3 py-2"
                    v-if="artist.collective != 1"
                  >
                    <v-btn-toggle v-model="artist.gender">
                      <v-btn
                        small
                        flat
                        v-for="s in constants.GENDERS"
                        :key="s.name"
                        class="px-2"
                        :value="s.name"
                      >
                        <span> {{ s.name }} </span>
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>

                  <v-flex xs12 v-if="artist.collective == 1">
                    <v-autocomplete
                      v-model="artist.artists"
                      :items="artists"
                      label="Artists in this collective"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-layout class="ml-3 mr-0 pr-0 mb-3 justify-end align-center">
              <v-spacer></v-spacer>
              <v-btn right small color="black" flat @click="$router.go(-1)"
                >CANCEL</v-btn
              >
              <v-btn
                right
                small
                class="mr-0"
                color="primary"
                @click="saveArtist"
                >SAVE</v-btn
              >
            </v-layout>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
    <!-- <v-stepper v-model="e1" style="background-color:#eee" non-linear>
      <v-stepper-header> 
        <v-stepper-step :complete="e1 > 1" v-for="tab in fields.tabs" :key="tab.key" :step="tab.key">{{tab.title}}</v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        
    <v-stepper-content v-for="tab in fields.tabs" :key="tab.key" :step="tab.key">-->

    <!-- <v-container fluid px-0 py-0>
            <v-layout row wrap>
              <v-flex xs12 sm12>

                <v-container px-1 py-0 v-if="!field.component">
                  <v-layout row wrap>
                      <component v-for="(field, index) in fields"
                        :class="'flex d-flex ' + field.class"
                        :key="index"
                        :is="field.component"
                        :value="artistFormData[field.name]"
                        :field="field"
                        :artist="artistFormData"
                        @input="updateForm(field.name, $event.value)"
                        >
                      </component-->
    <!-- <v-btn :disabled="!valid" @click="submit" > submit </v-btn>
    <v-btn @click="clear">clear</v-btn>-->
    <!-- </v-layout>
                </v-container>
              
                <v-container grid-list-xs fluid class="xs12 sm6" v-else >
                  <v-layout row wrap class="xs12">
                    <component v-bind:is="field.component" :artist="artistFormData"></component>
                  </v-layout>
                </v-container>

              </v-flex>
    </v-layout>-->
    <!-- </v-container> -->
    <!-- <v-btn color="primary" @click.native="e1 = field.btn">Next</v-btn>
    <v-btn flat>Cancel</v-btn>-->
    <!-- </v-stepper-content>

      </v-stepper-items>

    </v-stepper>-->
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import EditField from './EditField'
import EditFieldHeader from '@/components/artists/EditFieldHeader'
import ViewArtworks from '@/components/artists/ViewArtworks'
// import * as qs from 'querystring'
import MultiArtist from '@/components/artists/MultiArtist.vue'
import countries from '@/data/countries'
import constants from '@/data/constants'
import SectionHeader from '../layout/SectionHeader.vue'

export default {
  data() {
    return {
      constants: constants,
      name_exists: false,
      // fields: fields.fields,
      // e1: 1,
      // countries: this.constants.COUNTRIES,
      countries: countries.countries,
      artists: Object.assign([], this.$store.state.artists).sort(),
      // artistFormData: Object.assign({}, this.artist),
      valid: true,
      currentTab: this.$store.state.currentTabArtist,
      menu2: false,
      artist: {
        name: '',
        first_name: '',
        last_name: '',
        sort_name: '',
        collective: '0',
        birth_date: '',
        birth_city: '',
        birth_country: '',
      },
    }
  },
  // props: ['artist', 'field'],
  beforeMount() {
    this.result = this.$route.params.artist
    // this.getArtist()
  },
  methods: {
    check_name(value) {
      if (value) {
        var a = Object.assign([], this.$store.state.artists)
        var b = a.filter((aa) => aa.name === value)
        this.name_exists = b.length > 0
      }
    },
    saveArtist() {
      // if (this.$refs.form.validate()) {
      // console.log(this.artwork)
      if (
        this.artist.birth_date_year &&
        this.artist.birth_date_month &&
        this.artist.birth_date_day
      ) {
        this.artist.birth_date = `${this.artist.birth_date_year}-${this.artist.birth_date_month}-${this.artist.birth_date_day}`
      }
      let url = `${this.$globals.apiserver}/artists.json`
      // console.log(url)
      this.artist.created_by = this.c_user.id
      axios
        .post(url, this.artist)
        .then((response) => {
          // this.loading = false;
          // console.log(response.data)
          this.result = response.data
          this.artist = response.data
          this.$store.dispatch('addArtist', response.data)
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
          this.$router.push({
            name: 'EditArtist',
            // path: `/artists/edit/${this.artist.id}`,
            params: { id: this.artist.id, artist: this.artist },
          })
        })
        .catch((error) => {
          // console.log(error)
        })
      // }
    },
    // submit () {
    //   const art = this.artistFormData
    //   const requestConfig = {
    //       url     : `http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`,
    //       method  : "POST",
    //       // headers : { "Content-Type" : "application/x-www-form-urlencoded" },
    //       data : qs.stringify(art)
    //   }
    //   const response = axios.request(requestConfig)
    // },
    clear() {
      this.$refs.form.reset()
    },
    // updateForm (fieldName, value) {
    //   this.$set(this.artistFormData, fieldName, value)
    //   // this.$emit("input", this.artist);
    // },
    saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTabArtist', tab)
    },
    getArtist() {
      // console.log('getArtist')
      let url = `http://www.tb-cms.org/artists/${this.$route.params.id}.json`
      // console.log(url)
      axios
        .get(url)
        .then((response) => {
          // this.loading = false;
          this.result = response.data
        })
        .catch((error) => {
          // console.log(error)
        })
    },
  },
  computed: {
    processedArtist() {
      let processedArtist = Object.assign({}, this.result)
      return processedArtist
    },
  },
  components: {
    EditField,
    MultiArtist,
    EditFieldHeader,
    ViewArtworks,
    SectionHeader,
  },
}
</script>

<style scoped>
h1 {
  font-size: 1em !important;
  margin-left: 10px;
}
small {
  font-size: 1em;
  float: left;
  display: block;
}
.v-tabs-bar {
  top: 200px;
  position: fixed;
  z-index: 1;
}
.toolbar {
  margin-top: 0px;
  top: 80px;
  position: fixed;
  z-index: 1;
}
div.tabs__bar.theme--dark.grey {
  margin-top: 0px;
  top: 200px;
  position: fixed;
  z-index: 1;
}
.tabs__items {
  margin-top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/artists/AddArtist.vue